export const CheckoutButtons = {
  NEXT_STEP: 'Next Step',
  SIGN_IN: 'Sign In',
  PROCESSING: 'Processing',
  CONTINUE_PAYMENT: 'CONTINUE TO PAYMENT',
  CREATE_ACCOUNT: 'Create your account',
  LOGIN: 'Log in',
};
